var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDummyAm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14359_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M88.007,384.034c89.466,46.738,234.521,46.739,323.986,0.002 c89.467-46.739,89.467-122.517,0-169.254c-89.467-46.739-234.521-46.739-323.987-0.001C-1.46,261.519-1.46,337.297,88.007,384.034 z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shadows"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M99.166,302.603c-8.974,4.277-23.522,4.277-32.496,0c-8.974-4.276-8.974-11.211,0-15.488 c8.974-4.276,23.522-4.276,32.496,0C108.14,291.392,108.14,298.326,99.166,302.603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M366.852,316.147c-11.977,5.709-31.397,5.709-43.376,0c-11.978-5.708-11.978-14.965,0-20.674 c11.978-5.708,31.398-5.708,43.376,0C378.831,301.183,378.831,310.44,366.852,316.147z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plants"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M436.853,245.657c0,0,2.362-7.319,10.073-15.118c3.403-3.443,5.628-5.84,4.91-7.887 c-0.637-1.815-2.802-2.756-5.886-1.292c-4.392,2.084-7.354,5.937-9.098,13.695V245.657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M436.853,245.657c0,0,2.362-7.319,10.073-15.118c3.403-3.443,5.628-5.84,4.91-7.887 c-0.637-1.815-2.802-2.756-5.886-1.292c-4.392,2.084-7.354,5.937-9.098,13.695V245.657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M436.364,241.059c-0.031,0-0.063-0.004-0.094-0.012c-0.201-0.052-0.321-0.256-0.269-0.457 c2.751-10.617,9.858-17.196,12.87-18.719c0.183-0.094,0.41-0.02,0.504,0.165c0.093,0.185,0.019,0.411-0.166,0.504 c-2.912,1.473-9.796,7.869-12.482,18.239C436.684,240.947,436.531,241.059,436.364,241.059z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14412_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14413_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M436.854,254.755c0,0,3.288-6.459,7.259-9.88c3.972-3.421,9.07-6.934,4.746-9.612 c-4.443-2.751-11.428,2.578-12.005,7.766V254.755z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14414_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M436.364,250.156c-0.028,0-0.057-0.003-0.085-0.01c-0.202-0.047-0.327-0.249-0.28-0.451 c1.869-7.993,8.577-12.518,10.81-13.262c0.194-0.066,0.408,0.041,0.474,0.237c0.065,0.197-0.04,0.409-0.237,0.475 c-2.04,0.68-8.541,5.132-10.315,12.721C436.689,250.04,436.535,250.156,436.364,250.156z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M144.388,319.581c0,0-1.523-3.383-7.866-4.812c-6.177-1.392-9.248-0.053-13.421-0.715 c-4.226-0.67-3.086-8.513,8.14-7.705c10.267,0.737,13.147,8.82,13.147,8.82V319.581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M145.004,317.723c-0.148,0-0.288-0.088-0.347-0.233c-0.975-2.392-4.694-6.292-9.911-7.479 c-6.463-1.468-9.904,0.022-9.938,0.037c-0.189,0.085-0.411,0.001-0.496-0.189c-0.085-0.189,0-0.411,0.189-0.495 c0.149-0.066,3.708-1.608,10.411-0.084c5.788,1.316,9.475,5.561,10.439,7.927c0.078,0.191-0.014,0.411-0.206,0.489 C145.099,317.714,145.051,317.723,145.004,317.723z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M144.388,315.73c0,0-1.332-2.732-4.797-6.073c-6.027-5.814-13.97-7.648-18.043-10.826 c-4.396-3.431,0.932-7.396,6.591-7.139c3.243,0.146,6.66,2.288,8.545,3.83c6.616,5.411,7.704,14.135,7.704,14.135V315.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M144.388,315.73c0,0-1.332-2.732-4.797-6.073 c-6.027-5.814-13.97-7.648-18.043-10.826c-4.396-3.431,0.932-7.396,6.591-7.139c3.243,0.146,6.66,2.288,8.545,3.83 c6.616,5.411,7.704,14.135,7.704,14.135V315.73z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M145.003,315.145c-0.186,0-0.347-0.138-0.372-0.327c-0.007-0.059-0.822-5.979-5.523-11.329 c-4.72-5.371-12.793-8.247-12.874-8.275c-0.195-0.068-0.298-0.282-0.23-0.477c0.069-0.195,0.281-0.301,0.478-0.23 c0.338,0.118,8.341,2.97,13.189,8.488c4.858,5.53,5.671,11.478,5.704,11.728c0.026,0.205-0.119,0.393-0.324,0.42 C145.036,315.144,145.019,315.145,145.003,315.145z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M281.634,377.877c0,0,1.701-3.297,8.112-4.384c6.243-1.06,9.237,0.442,13.439,0.005 c4.255-0.443,3.537-8.335-7.715-8.13c-10.292,0.188-13.601,8.104-13.601,8.104L281.634,377.877z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M281.634,377.877c0,0,1.701-3.297,8.112-4.384c6.243-1.06,9.237,0.442,13.439,0.005 c4.255-0.443,3.537-8.335-7.715-8.13c-10.292,0.188-13.601,8.104-13.601,8.104L281.634,377.877z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M281.138,376.296c-0.074,0-0.149-0.021-0.215-0.067c-0.17-0.119-0.211-0.352-0.093-0.522 c2.387-3.417,6.742-5.98,11.651-6.855c6.308-1.126,10.006,0.87,10.16,0.955c0.181,0.101,0.246,0.328,0.146,0.509 c-0.1,0.181-0.326,0.247-0.51,0.147c-0.035-0.02-3.631-1.948-9.666-0.873c-4.717,0.841-8.892,3.289-11.167,6.547 C281.372,376.24,281.256,376.296,281.138,376.296z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M282.081,373.254c0,0,1.251-1.801,4.89-4.952c6.33-5.483,14.344-6.375,18.581-9.33 c4.574-3.19-0.534-7.435-6.199-7.482c-3.246-0.026-6.772,1.929-8.738,3.367c-6.896,5.05-8.98,12.468-8.98,12.468L282.081,373.254 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M282.081,373.254c0,0,1.251-1.801,4.89-4.952c6.33-5.483,14.344-6.375,18.581-9.33 c4.574-3.19-0.534-7.435-6.199-7.482c-3.246-0.026-6.772,1.929-8.738,3.367c-6.896,5.05-8.98,12.468-8.98,12.468L282.081,373.254 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M281.138,373.175c-0.037,0-0.076-0.006-0.113-0.018c-0.197-0.063-0.307-0.273-0.244-0.471 c0.019-0.061,2.023-6.251,7.218-11.434c6.013-5.999,12.639-6.844,12.918-6.876c0.201-0.026,0.392,0.122,0.416,0.328 c0.024,0.205-0.122,0.392-0.328,0.416c-0.065,0.008-6.656,0.855-12.477,6.663c-5.059,5.049-7.013,11.07-7.032,11.13 C281.444,373.073,281.297,373.175,281.138,373.175z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Bar_Charts"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M185.006,320.424c0-0.002,0-0.005,0-0.007v-75.55h-40.62v75.562h0.001 c0.004,2.998,1.986,5.996,5.948,8.283c7.931,4.579,20.791,4.579,28.722,0c3.962-2.287,5.944-5.285,5.948-8.283h0V320.424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0,
      fill: "#E0E0E0"
    },
    d: "M185.006,320.424c0-0.002,0-0.005,0-0.007v-75.55h-40.62v75.562h0.001 c0.004,2.998,1.986,5.996,5.948,8.283c7.931,4.579,20.791,4.579,28.722,0c3.962-2.287,5.944-5.285,5.948-8.283h0V320.424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M150.336,253.665c-7.931-4.579-7.931-12.004,0-16.583c7.932-4.579,20.791-4.579,28.723,0 s7.932,12.004,0,16.583C171.127,258.244,158.268,258.244,150.336,253.665z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M233.751,348.566c0-0.002,0-0.004,0-0.007v-54.982h-40.62v54.993h0.001 c0.003,2.998,1.986,5.996,5.948,8.283c7.932,4.579,20.791,4.579,28.723,0c3.962-2.287,5.944-5.285,5.948-8.283h0V348.566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0,
      fill: "#E0E0E0"
    },
    d: "M233.751,348.566c0-0.002,0-0.004,0-0.007v-54.982h-40.62v54.993h0.001 c0.003,2.998,1.986,5.996,5.948,8.283c7.932,4.579,20.791,4.579,28.723,0c3.962-2.287,5.944-5.285,5.948-8.283h0V348.566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M199.081,302.376c-7.932-4.579-7.932-12.003,0-16.583c7.932-4.579,20.791-4.579,28.723,0 c7.931,4.58,7.931,12.004,0,16.583C219.873,306.956,207.013,306.956,199.081,302.376z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M282.497,376.71c0-0.003,0-0.005,0-0.008v-42.717h-40.62v42.728h0 c0.004,2.999,1.986,5.996,5.948,8.283c7.932,4.58,20.791,4.58,28.723,0c3.962-2.287,5.944-5.284,5.947-8.283h0.001V376.71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0,
      fill: "#E0E0E0"
    },
    d: "M282.497,376.71c0-0.003,0-0.005,0-0.008v-42.717h-40.62v42.728h0 c0.004,2.999,1.986,5.996,5.948,8.283c7.932,4.58,20.791,4.58,28.723,0c3.962-2.287,5.944-5.284,5.947-8.283h0.001V376.71z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#455A64"
    },
    cx: 262.188,
    cy: 334.492,
    rx: 20.31,
    ry: 11.726
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M141.789,347.064l-9.588-5.536l5.313-6.88c0.675-0.875,0.355-1.36-0.714-1.085l-12.722,3.274 l-9.588-5.536c-1.435-0.828-3.762-0.828-5.197,0l-15.114,8.727c-1.435,0.828-1.435,2.172,0,3l27.3,15.762 c1.435,0.828,3.761,0.828,5.196,0l15.114-8.726C143.224,349.234,143.224,347.892,141.789,347.064z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M126.447,343.671c0.178-0.013,0.335-0.011,0.474,0.005c0.14,0.017,0.287,0.069,0.441,0.158 l1.363,0.788c0.123,0.07,0.189,0.145,0.2,0.221c0.013,0.077-0.033,0.145-0.133,0.201c-0.023,0.014-0.055,0.026-0.099,0.039 c-0.046,0.013-0.095,0.022-0.15,0.029l-19.031,1.498c-0.177,0.013-0.336,0.011-0.473-0.005c-0.14-0.017-0.286-0.069-0.441-0.159 l-1.364-0.787c-0.121-0.07-0.188-0.145-0.2-0.221c-0.011-0.077,0.034-0.145,0.135-0.202c0.021-0.013,0.055-0.025,0.1-0.038 c0.044-0.013,0.094-0.022,0.149-0.028L126.447,343.671z M120.326,342.403c-0.411,0.275-0.832,0.519-1.265,0.73 c-0.354,0.179-0.726,0.319-1.114,0.422c-0.389,0.103-0.798,0.154-1.232,0.154c-0.432,0-0.869-0.058-1.313-0.174 c-0.443-0.114-0.882-0.297-1.313-0.547c-0.434-0.25-0.75-0.503-0.949-0.759c-0.199-0.256-0.297-0.508-0.291-0.754 c0.006-0.246,0.094-0.483,0.267-0.711c0.171-0.227,0.413-0.443,0.723-0.647c0.2-0.142,0.396-0.268,0.591-0.38 c0.194-0.112,0.418-0.23,0.674-0.351c0.356-0.18,0.73-0.318,1.123-0.418c0.394-0.099,0.805-0.15,1.231-0.153 c0.427-0.004,0.862,0.053,1.305,0.168c0.443,0.115,0.882,0.298,1.315,0.548c0.432,0.249,0.748,0.502,0.947,0.758 c0.201,0.257,0.297,0.508,0.291,0.754c-0.006,0.247-0.094,0.484-0.266,0.711C120.878,341.982,120.636,342.198,120.326,342.403z  M122.222,350.221c-0.409,0.276-0.831,0.52-1.264,0.73c-0.355,0.179-0.726,0.32-1.114,0.423c-0.39,0.102-0.798,0.153-1.232,0.153 c-0.433,0-0.87-0.058-1.313-0.173c-0.444-0.115-0.882-0.298-1.314-0.548c-0.432-0.249-0.749-0.503-0.948-0.759 c-0.2-0.256-0.297-0.507-0.291-0.754c0.006-0.246,0.094-0.483,0.266-0.711c0.173-0.227,0.413-0.443,0.725-0.648 c0.199-0.141,0.396-0.267,0.59-0.38c0.194-0.111,0.419-0.229,0.674-0.351c0.354-0.179,0.729-0.318,1.123-0.418 c0.394-0.099,0.805-0.149,1.231-0.153c0.427-0.003,0.86,0.053,1.306,0.168c0.442,0.115,0.882,0.298,1.313,0.548 c0.433,0.25,0.748,0.502,0.948,0.759c0.199,0.256,0.297,0.508,0.291,0.754c-0.006,0.246-0.094,0.483-0.266,0.71 C122.773,349.8,122.533,350.017,122.222,350.221z M115.851,341.184c-0.266,0.18-0.424,0.338-0.474,0.476 c-0.05,0.138,0.047,0.276,0.292,0.418c0.243,0.141,0.484,0.196,0.723,0.168c0.238-0.029,0.513-0.12,0.824-0.274 c0.399-0.191,0.765-0.402,1.098-0.634c0.266-0.179,0.424-0.338,0.474-0.475c0.05-0.138-0.047-0.277-0.29-0.418 c-0.245-0.142-0.486-0.197-0.725-0.168c-0.238,0.028-0.513,0.12-0.823,0.273C116.55,340.742,116.184,340.953,115.851,341.184z  M117.748,349.001c-0.267,0.18-0.425,0.338-0.476,0.476c-0.049,0.138,0.049,0.277,0.292,0.418c0.244,0.141,0.485,0.197,0.724,0.168 c0.239-0.028,0.513-0.12,0.824-0.273c0.398-0.192,0.765-0.403,1.098-0.634c0.266-0.18,0.424-0.338,0.474-0.476 c0.051-0.138-0.047-0.276-0.291-0.418c-0.243-0.141-0.485-0.196-0.725-0.168c-0.237,0.029-0.512,0.12-0.822,0.273 C118.446,348.56,118.081,348.772,117.748,349.001z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M194.614,377.541l-9.588-5.536l5.313-6.88c0.675-0.875,0.355-1.36-0.714-1.085l-12.722,3.275 l-9.588-5.536c-1.435-0.828-3.761-0.828-5.196,0l-15.114,8.727c-1.435,0.828-1.435,2.171,0,3l27.3,15.762 c1.435,0.828,3.761,0.828,5.196,0l15.114-8.726C196.049,379.712,196.049,378.369,194.614,377.541z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M179.272,374.148c0.178-0.013,0.335-0.011,0.474,0.005c0.14,0.017,0.287,0.069,0.441,0.158 l1.363,0.788c0.123,0.07,0.189,0.145,0.2,0.221c0.013,0.077-0.033,0.145-0.133,0.201c-0.023,0.014-0.055,0.026-0.099,0.039 c-0.046,0.013-0.095,0.023-0.15,0.029l-19.031,1.498c-0.177,0.013-0.336,0.011-0.473-0.005c-0.14-0.017-0.286-0.069-0.441-0.159 l-1.364-0.787c-0.121-0.07-0.189-0.145-0.2-0.221c-0.011-0.077,0.034-0.144,0.135-0.202c0.021-0.013,0.055-0.025,0.1-0.038 c0.044-0.013,0.094-0.023,0.149-0.028L179.272,374.148z M173.151,372.881c-0.411,0.275-0.832,0.519-1.265,0.73 c-0.354,0.179-0.726,0.319-1.114,0.422c-0.389,0.103-0.798,0.154-1.232,0.154c-0.432,0-0.869-0.058-1.313-0.174 c-0.443-0.114-0.882-0.297-1.314-0.547c-0.434-0.25-0.75-0.503-0.949-0.759c-0.199-0.256-0.297-0.508-0.291-0.754 c0.006-0.246,0.094-0.483,0.267-0.711c0.171-0.227,0.413-0.443,0.723-0.647c0.2-0.142,0.396-0.268,0.591-0.38 c0.194-0.112,0.418-0.229,0.674-0.351c0.356-0.18,0.73-0.318,1.123-0.418c0.393-0.099,0.805-0.15,1.231-0.153 c0.427-0.004,0.862,0.053,1.305,0.168c0.443,0.115,0.882,0.298,1.315,0.548c0.432,0.249,0.748,0.502,0.947,0.758 c0.201,0.257,0.297,0.508,0.291,0.754c-0.006,0.247-0.094,0.484-0.266,0.711C173.703,372.46,173.46,372.676,173.151,372.881z  M175.046,380.698c-0.409,0.276-0.831,0.52-1.264,0.73c-0.354,0.179-0.726,0.32-1.114,0.423c-0.39,0.102-0.798,0.153-1.231,0.153 c-0.433,0-0.87-0.058-1.314-0.173c-0.444-0.115-0.882-0.298-1.314-0.548c-0.432-0.249-0.749-0.503-0.948-0.759 c-0.2-0.256-0.297-0.507-0.291-0.754c0.006-0.246,0.094-0.483,0.266-0.711c0.173-0.226,0.413-0.443,0.725-0.647 c0.199-0.141,0.396-0.268,0.59-0.38c0.194-0.111,0.419-0.229,0.674-0.351c0.355-0.179,0.73-0.318,1.123-0.418 c0.393-0.099,0.805-0.149,1.231-0.153c0.427-0.003,0.86,0.053,1.306,0.168c0.442,0.115,0.882,0.298,1.314,0.548 c0.433,0.25,0.748,0.502,0.948,0.759c0.199,0.256,0.297,0.508,0.291,0.754c-0.006,0.246-0.094,0.483-0.266,0.71 C175.598,380.277,175.358,380.494,175.046,380.698z M168.675,371.661c-0.266,0.18-0.424,0.338-0.474,0.476 c-0.05,0.138,0.047,0.276,0.292,0.418c0.243,0.141,0.484,0.196,0.723,0.168c0.238-0.029,0.513-0.12,0.824-0.274 c0.398-0.191,0.765-0.402,1.098-0.634c0.266-0.179,0.424-0.338,0.474-0.475c0.05-0.138-0.047-0.277-0.29-0.418 c-0.245-0.142-0.486-0.197-0.725-0.168c-0.238,0.028-0.513,0.12-0.823,0.273C169.374,371.22,169.008,371.431,168.675,371.661z  M170.573,379.478c-0.267,0.18-0.425,0.338-0.476,0.476c-0.049,0.138,0.049,0.277,0.292,0.418c0.244,0.141,0.485,0.197,0.724,0.168 c0.239-0.028,0.513-0.12,0.824-0.273c0.398-0.192,0.765-0.403,1.098-0.634c0.266-0.18,0.424-0.338,0.474-0.476 c0.051-0.138-0.047-0.276-0.291-0.418c-0.243-0.141-0.485-0.196-0.725-0.168c-0.237,0.029-0.512,0.12-0.822,0.273 C171.271,379.037,170.906,379.249,170.573,379.478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M247.391,408.03l-9.588-5.535l5.313-6.881c0.675-0.874,0.355-1.359-0.714-1.084l-12.722,3.274 l-9.588-5.536c-1.434-0.828-3.761-0.828-5.196,0l-15.114,8.726c-1.435,0.829-1.435,2.172,0,3l27.3,15.763 c1.435,0.828,3.761,0.828,5.196,0l15.114-8.727C248.826,410.202,248.826,408.858,247.391,408.03z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M232.049,404.638c0.178-0.013,0.335-0.011,0.474,0.005c0.14,0.017,0.287,0.069,0.441,0.158 l1.363,0.788c0.123,0.07,0.189,0.145,0.2,0.221c0.013,0.077-0.033,0.145-0.133,0.201c-0.022,0.014-0.055,0.026-0.099,0.039 c-0.046,0.013-0.095,0.022-0.15,0.029l-19.031,1.498c-0.177,0.013-0.336,0.011-0.473-0.005c-0.14-0.017-0.286-0.069-0.441-0.159 l-1.364-0.787c-0.121-0.07-0.189-0.145-0.2-0.221c-0.011-0.077,0.034-0.145,0.135-0.202c0.021-0.013,0.055-0.025,0.1-0.038 c0.044-0.013,0.094-0.022,0.149-0.028L232.049,404.638z M225.928,403.37c-0.411,0.275-0.832,0.519-1.265,0.73 c-0.354,0.179-0.727,0.319-1.114,0.422c-0.389,0.103-0.798,0.154-1.231,0.154c-0.432,0-0.869-0.058-1.313-0.174 c-0.443-0.114-0.882-0.297-1.314-0.547c-0.434-0.25-0.75-0.503-0.949-0.759c-0.199-0.256-0.297-0.508-0.291-0.754 c0.006-0.246,0.094-0.483,0.267-0.711c0.171-0.227,0.413-0.443,0.723-0.647c0.2-0.142,0.396-0.268,0.591-0.38 c0.194-0.112,0.418-0.23,0.674-0.351c0.355-0.18,0.73-0.318,1.123-0.418c0.394-0.099,0.805-0.15,1.232-0.153 c0.427-0.004,0.862,0.053,1.305,0.168c0.443,0.115,0.882,0.298,1.315,0.548c0.432,0.249,0.748,0.502,0.947,0.758 c0.201,0.257,0.297,0.508,0.291,0.754c-0.006,0.247-0.094,0.484-0.266,0.711C226.48,402.949,226.238,403.165,225.928,403.37z  M227.824,411.188c-0.409,0.276-0.831,0.52-1.264,0.73c-0.354,0.179-0.726,0.32-1.114,0.423c-0.39,0.102-0.798,0.153-1.231,0.153 c-0.433,0-0.87-0.058-1.313-0.173c-0.444-0.115-0.882-0.298-1.314-0.548c-0.432-0.249-0.749-0.503-0.948-0.759 c-0.2-0.256-0.297-0.507-0.291-0.754c0.006-0.246,0.094-0.483,0.266-0.711c0.173-0.227,0.413-0.443,0.725-0.647 c0.199-0.141,0.396-0.268,0.59-0.38c0.194-0.111,0.419-0.229,0.674-0.351c0.355-0.179,0.73-0.318,1.123-0.418 c0.394-0.099,0.805-0.149,1.232-0.153c0.427-0.003,0.86,0.053,1.306,0.168c0.442,0.115,0.882,0.298,1.314,0.548 c0.433,0.25,0.748,0.502,0.948,0.759c0.199,0.256,0.297,0.508,0.291,0.754c-0.006,0.246-0.094,0.483-0.266,0.71 C228.375,410.767,228.135,410.983,227.824,411.188z M221.453,402.15c-0.266,0.18-0.424,0.338-0.474,0.476 c-0.05,0.138,0.047,0.276,0.292,0.418c0.243,0.141,0.484,0.196,0.723,0.168c0.238-0.029,0.513-0.12,0.824-0.274 c0.398-0.191,0.765-0.402,1.098-0.634c0.266-0.179,0.424-0.338,0.474-0.475c0.05-0.138-0.047-0.277-0.29-0.418 c-0.245-0.142-0.486-0.197-0.725-0.168c-0.238,0.028-0.513,0.12-0.823,0.273C222.152,401.709,221.786,401.92,221.453,402.15z  M223.35,409.968c-0.267,0.18-0.425,0.338-0.476,0.476c-0.049,0.138,0.049,0.277,0.292,0.418c0.244,0.141,0.485,0.197,0.724,0.168 c0.239-0.028,0.513-0.12,0.824-0.273c0.398-0.192,0.765-0.403,1.098-0.634c0.266-0.18,0.424-0.338,0.474-0.476 c0.051-0.138-0.047-0.276-0.291-0.418c-0.243-0.141-0.485-0.196-0.725-0.168c-0.237,0.029-0.512,0.12-0.822,0.274 C224.048,409.526,223.683,409.738,223.35,409.968z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14347_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14350_"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#37474F"
    },
    points: "384.048,243.029 367.8,233.648 367.799,186.743 384.047,196.124  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14349_"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#455A64"
    },
    points: "384.047,243.029 400.296,233.648 400.296,186.743 384.047,196.124  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14348_"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#455A64"
    },
    points: "367.799,186.743 384.047,196.124 400.296,186.743 384.048,177.362  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14351_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14381_"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#37474F"
    },
    points: "347.489,221.921 331.241,212.54 331.24,118.732 347.488,128.113  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14353_"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#455A64"
    },
    points: "347.488,221.921 363.737,212.54 363.737,118.732 347.488,128.113  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14352_"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#455A64"
    },
    points: "331.24,118.732 347.488,128.113 363.737,118.732 347.488,109.351  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14346_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14411_"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#37474F"
    },
    points: "310.93,200.814 294.682,191.433 294.681,158.6 310.929,167.981  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14410_"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#455A64"
    },
    points: "310.929,200.814 327.178,191.433 327.178,158.6 310.929,167.981  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14408_"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#455A64"
    },
    points: "294.681,158.6 310.929,167.981 327.178,158.6 310.929,149.22  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14343_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_30_"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#37474F"
    },
    points: "420.605,264.136 404.357,254.755 404.357,165.636 420.604,175.017  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14267_"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#455A64"
    },
    points: "420.604,264.136 436.854,254.755 436.854,165.636 420.604,175.017  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14301_"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#455A64"
    },
    points: "404.357,165.636 420.604,175.017 436.854,165.636 420.605,156.255  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Main_Charts"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14311_",
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M307.01,257.332l-0.169-103.881c-0.002-1.105-0.779-2.446-1.737-2.997L182.532,79.958 c-0.957-0.551-1.732-0.102-1.73,1.003l0.168,103.88c0.002,1.104,0.779,2.446,1.737,2.997l122.573,70.497 C306.238,258.886,307.012,258.438,307.01,257.332z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14310_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M306.058,259.069c-0.327,0.001-0.68-0.1-1.028-0.301l-122.573-70.496 c-1.113-0.64-1.986-2.147-1.988-3.43l-0.168-103.88c-0.001-0.71,0.274-1.277,0.755-1.555c0.48-0.28,1.109-0.236,1.725,0.118 l122.572,70.496c1.112,0.64,1.986,2.146,1.988,3.43l0.169,103.881c0.001,0.721-0.267,1.273-0.754,1.556 C306.546,259.009,306.31,259.069,306.058,259.069z M181.761,80.223c-0.078,0-0.146,0.016-0.203,0.049 c-0.163,0.094-0.257,0.346-0.256,0.689l0.168,103.88c0.001,0.928,0.682,2.102,1.486,2.564l122.573,70.497 c0.298,0.17,0.562,0.215,0.726,0.12c0.163-0.094,0.256-0.345,0.256-0.689l-0.169-103.881c-0.001-0.928-0.682-2.102-1.487-2.564 L182.283,80.392C182.088,80.28,181.908,80.223,181.761,80.223z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14316_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M295.36,234.412c-3.248-2.312-5.149-4.403-6.443-20.463l-0.111-1.369 c-1.21-15.085-2.01-25.051-8.879-29.16c-3.297-1.972-5.935,0.04-8.73,2.171c-2.524,1.924-5.132,3.91-8.053,2.234 c-5.155-2.963-6.025-8.935-7.605-19.777c-0.194-1.335-0.4-2.744-0.625-4.23c-0.35-2.304-0.651-4.459-0.931-6.474 c-1.586-11.387-2.543-18.26-8.36-21.772c-1.415-0.855-2.715-1.057-3.971-0.617c-4.409,1.543-7.861,10.877-11.517,20.76 c-0.273,0.738-0.551,1.501-0.834,2.279c-2.651,7.29-5.657,15.553-9.805,17.087c-1.178,0.435-2.382,0.314-3.583-0.364 c-4.139-2.333-4.875-8.742-5.586-14.94c-0.701-6.112-1.427-12.431-5.308-14.756c-0.731-0.439-1.468-0.503-2.253-0.195 c-4.839,1.886-9.127,16.2-9.169,16.344l-0.958-0.284c0.18-0.609,4.474-14.931,9.764-16.992c1.078-0.421,2.131-0.33,3.131,0.269 c4.305,2.578,5.058,9.147,5.787,15.5c0.714,6.222,1.389,12.1,5.084,14.183c0.946,0.534,1.844,0.63,2.745,0.297 c3.714-1.374,6.762-9.756,9.212-16.491c0.283-0.779,0.561-1.544,0.835-2.284c3.902-10.548,7.271-19.658,12.125-21.357 c1.533-0.537,3.155-0.3,4.818,0.705c6.224,3.759,7.206,10.81,8.833,22.491c0.28,2.01,0.58,4.162,0.928,6.461 c0.226,1.488,0.431,2.899,0.627,4.236c1.535,10.532,2.38,16.333,7.114,19.054c2.346,1.348,4.477-0.279,6.949-2.162 c2.799-2.134,5.973-4.551,9.85-2.234c7.311,4.373,8.126,14.543,9.361,29.937l0.11,1.369c1.321,16.379,3.295,17.784,6.028,19.729 L295.36,234.412z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7_",
    style: {
      opacity: 0.4
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M295.36,234.412c-3.248-2.312-5.149-4.403-6.443-20.463l-0.111-1.369c-1.21-15.085-2.01-25.051-8.879-29.16 c-3.297-1.972-5.935,0.04-8.73,2.171c-2.524,1.924-5.132,3.91-8.053,2.234c-5.155-2.963-6.025-8.935-7.605-19.777 c-0.194-1.335-0.4-2.744-0.625-4.23c-0.35-2.304-0.651-4.459-0.931-6.474c-1.586-11.387-2.543-18.26-8.36-21.772 c-1.415-0.855-2.715-1.057-3.971-0.617c-4.409,1.543-7.861,10.877-11.517,20.76c-0.273,0.738-0.551,1.501-0.834,2.279 c-2.651,7.29-5.657,15.553-9.805,17.087c-1.178,0.435-2.382,0.314-3.583-0.364c-4.139-2.333-4.875-8.742-5.586-14.94 c-0.701-6.112-1.427-12.431-5.308-14.756c-0.731-0.439-1.468-0.503-2.253-0.195c-4.839,1.886-9.127,16.2-9.169,16.344 l-0.958-0.284c0.18-0.609,4.474-14.931,9.764-16.992c1.078-0.421,2.131-0.33,3.131,0.269c4.305,2.578,5.058,9.147,5.787,15.5 c0.714,6.222,1.389,12.1,5.084,14.183c0.946,0.534,1.844,0.63,2.745,0.297c3.714-1.374,6.762-9.756,9.212-16.491 c0.283-0.779,0.561-1.544,0.835-2.284c3.902-10.548,7.271-19.658,12.125-21.357c1.533-0.537,3.155-0.3,4.818,0.705 c6.224,3.759,7.206,10.81,8.833,22.491c0.28,2.01,0.58,4.162,0.928,6.461c0.226,1.488,0.431,2.899,0.627,4.236 c1.535,10.532,2.38,16.333,7.114,19.054c2.346,1.348,4.477-0.279,6.949-2.162c2.799-2.134,5.973-4.551,9.85-2.234 c7.311,4.373,8.126,14.543,9.361,29.937l0.11,1.369c1.321,16.379,3.295,17.784,6.028,19.729L295.36,234.412z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14342_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M278.45,179.041c1.414,0.814,2.563,2.797,2.566,4.428c0.003,1.632-1.142,2.295-2.556,1.482 c-1.415-0.814-2.564-2.796-2.567-4.428C275.89,178.891,277.034,178.227,278.45,179.041z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_9_",
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M278.45,179.041c1.414,0.814,2.563,2.797,2.566,4.428c0.003,1.632-1.142,2.295-2.556,1.482 c-1.415-0.814-2.564-2.796-2.567-4.428C275.89,178.891,277.034,178.227,278.45,179.041z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14344_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M245.877,132.19c1.415,0.814,2.564,2.796,2.566,4.428c0.003,1.632-1.142,2.296-2.557,1.482 c-1.415-0.814-2.564-2.796-2.566-4.428C243.318,132.039,244.462,131.376,245.877,132.19z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8_",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M245.877,132.19c1.415,0.814,2.564,2.796,2.566,4.428c0.003,1.632-1.142,2.296-2.557,1.482 c-1.415-0.814-2.564-2.796-2.566-4.428C243.318,132.039,244.462,131.376,245.877,132.19z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14345_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M205.273,141.636c1.414,0.814,2.564,2.796,2.566,4.428c0.003,1.632-1.142,2.296-2.557,1.482 c-1.415-0.814-2.564-2.796-2.566-4.428C202.713,141.486,203.858,140.823,205.273,141.636z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.65,
      fill: "#FFFFFF"
    },
    d: "M241.874,252.755V148.874c0-1.105-0.775-2.448-1.732-3l-106.21-61.321 c-0.956-0.552-1.732-0.104-1.732,1l-0.001,103.88c0,1.105,0.775,2.448,1.732,3l106.211,61.322 C241.099,254.308,241.874,253.859,241.874,252.755z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14309_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M240.919,254.49c-0.328,0-0.679-0.102-1.027-0.303l-106.21-61.321 c-1.112-0.642-1.982-2.149-1.982-3.433l0.001-103.88c0-0.71,0.276-1.276,0.757-1.554c0.482-0.279,1.109-0.234,1.725,0.121 l106.21,61.321c1.111,0.642,1.982,2.15,1.982,3.433v103.881c0,0.71-0.276,1.276-0.758,1.555 C241.408,254.431,241.171,254.49,240.919,254.49z M133.161,84.816c-0.078,0-0.146,0.016-0.203,0.048 c-0.164,0.095-0.257,0.346-0.257,0.688l-0.001,103.88c0,0.928,0.679,2.104,1.482,2.567l106.21,61.322 c0.297,0.171,0.56,0.214,0.725,0.121c0.164-0.095,0.257-0.346,0.257-0.689V148.874c0-0.928-0.679-2.103-1.482-2.567 l-106.21-61.321C133.488,84.874,133.308,84.816,133.161,84.816z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14278_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M223.596,229.14v-68.357c0-0.553-0.388-1.224-0.866-1.5l-10.455-6.036 c-0.479-0.276-0.866-0.052-0.866,0.5v68.357c0,0.552,0.388,1.224,0.866,1.5l10.455,6.036 C223.208,229.917,223.596,229.692,223.596,229.14z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_",
    style: {
      opacity: 0.3
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M223.596,229.14v-68.357c0-0.553-0.388-1.224-0.866-1.5l-10.455-6.036c-0.479-0.276-0.866-0.052-0.866,0.5v68.357 c0,0.552,0.388,1.224,0.866,1.5l10.455,6.036C223.208,229.917,223.596,229.692,223.596,229.14z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14280_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M203.286,217.414v-35.523c0-0.552-0.388-1.224-0.866-1.5l-10.455-6.036 c-0.478-0.276-0.866-0.052-0.866,0.5v35.523c0,0.552,0.388,1.224,0.866,1.5l10.455,6.036 C202.898,218.19,203.286,217.966,203.286,217.414z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5_",
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M203.286,217.414v-35.523c0-0.552-0.388-1.224-0.866-1.5l-10.455-6.036 c-0.478-0.276-0.866-0.052-0.866,0.5v35.523c0,0.552,0.388,1.224,0.866,1.5l10.455,6.036 C202.898,218.19,203.286,217.966,203.286,217.414z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14281_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M182.976,205.688v-54.285c0-0.552-0.388-1.224-0.866-1.5l-10.455-6.036 c-0.478-0.276-0.866-0.052-0.866,0.5v54.285c0,0.552,0.388,1.224,0.866,1.5l10.455,6.036 C182.588,206.464,182.976,206.24,182.976,205.688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_",
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M182.976,205.688v-54.285c0-0.552-0.388-1.224-0.866-1.5l-10.455-6.036c-0.478-0.276-0.866-0.052-0.866,0.5v54.285 c0,0.552,0.388,1.224,0.866,1.5l10.455,6.036C182.588,206.464,182.976,206.24,182.976,205.688z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14282_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M162.665,193.961v-77.737c0-0.552-0.388-1.224-0.866-1.5l-10.455-6.036 c-0.479-0.276-0.866-0.052-0.866,0.5v77.737c0,0.552,0.388,1.224,0.866,1.5l10.455,6.036 C162.277,194.737,162.665,194.514,162.665,193.961z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M378.63,206.427c-0.136-0.745-3.811-9.286-5.323-12.648l-7.648,3.582l2.928,6.71l7.926,6.126 C378.943,209.432,378.765,207.171,378.63,206.427z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.491,
    y: 295.885,
    style: {
      fill: "#FFA8A7"
    },
    width: 5.904,
    height: 8.598
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.874,
    y: 285.341,
    transform: "matrix(0.9994 -0.0344 0.0344 0.9994 -9.7675 11.8677)",
    style: {
      fill: "#FFA8A7"
    },
    width: 5.904,
    height: 8.599
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M344.081,172.717c-3.651,0.29-7.294,1.294-10.558,6.142c-3.264,4.847-8.977,13.143-8.977,13.143 l10.757,3.413L344.081,172.717z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M344.081,172.717c-3.651,0.29-7.294,1.294-10.558,6.142c-3.264,4.847-8.977,13.143-8.977,13.143 l10.757,3.413L344.081,172.717z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M363.008,211.947c0,5.638,0.729,42.111,0.729,42.111c0.138,1.623,1.658,4.614,1.329,10.845 c-0.447,8.465-1.179,31.979-1.179,31.979s-2.769,2.744-6.678,0c0,0-5.346-31.95-6.404-40.338 c-0.923-7.321-2.489-27.209-2.489-27.209l-5.471,23.41c0,0,0.963,5.503,1.174,9.387c0.212,3.885-1.002,26.318-1.002,26.318 s-3.001,2.074-6.425,0.245c0,0-4.743-32.777-5.353-36.286c-0.608-3.508,4.152-40.462,4.152-40.462H363.008z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M363.008,211.947c0,5.638,0.729,42.111,0.729,42.111c0.138,1.623,1.658,4.614,1.329,10.845 c-0.447,8.465-1.179,31.979-1.179,31.979s-2.769,2.744-6.678,0c0,0-5.346-31.95-6.404-40.338 c-0.923-7.321-2.489-27.209-2.489-27.209l-5.471,23.41c0,0,0.963,5.503,1.174,9.387c0.212,3.885-1.002,26.318-1.002,26.318 s-3.001,2.074-6.425,0.245c0,0-4.743-32.777-5.353-36.286c-0.608-3.508,4.152-40.462,4.152-40.462H363.008z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M354.12,172.898c5.294,1.274,12.012,3.412,14.363,8.291c2.352,4.879,5.981,12.788,5.981,12.788 l-8.766,5.181l-2.691-4.683v17.472c-4.141,4.504-18.574,6.603-27.615,0c0,0,0-24.183,0-28.782c0-4.599,2.555-10.124,9.61-10.534 L354.12,172.898z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M354.12,172.898c5.294,1.274,12.012,3.412,14.363,8.291 c2.352,4.879,5.981,12.788,5.981,12.788l-8.766,5.181l-2.691-4.683v17.472c-4.141,4.504-18.574,6.603-27.615,0 c0,0,0-24.183,0-28.782c0-4.599,2.555-10.124,9.61-10.534L354.12,172.898z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M356.107,149.361c0,0,1.463-0.25,2.603,0.916c1.118,1.144,0.886,3.26-0.002,8.124l-3.455,0.397 L356.107,149.361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M335.959,147.954c0,0-1.396,0.001-2.162-0.439c-1.061-0.609-1.338,0.596-0.756,1.644 c0.581,1.047,1.667,2.412,4.009,2.67c0.031-0.15,0.992-2.699,0.992-2.699L335.959,147.954z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M354.486,158.799c0.513,0.307,1.245-0.679,1.878-1.341c0.632-0.662,2.698-1.566,3.728,0.604 c1.051,2.212-1.333,5.154-2.732,6.127c-1.663,1.155-2.873,0.249-2.873,0.249l-0.366,8.46c0,0-1.835,4.489-6.804,5.163 c-4.969,0.674-3.945-3.422-2.313-5.43l0.008-3.076c0,0-2.566,0.517-3.777,0.194c-0.648-0.173-2.194-2.042-3.191-4.132 c-1.12-2.348-2.983-6.516-1.325-13.565c1.782-7.573,9.917-7.804,14.769-4.751C356.336,150.354,354.486,158.799,354.486,158.799z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M354.486,159.662c0.258,0.005,1.239-1.623,1.878-2.205c0.885-0.805-0.257-8.097-0.257-8.097 s0.896-2.766-0.854-4.6c-1.749-1.834-5.139-1.524-7.616-1.614c-2.579-0.093-5.339-0.249-8.859-1.777 c-3.52-1.529-3.782-1.71-4.219-0.164c-0.438,1.545-0.602,5.085,1.499,7.458l1.747,0.642c0,0,0.943,0.837,4.227,1.237 c3.282,0.4,8.395-0.077,9.095-0.172c0.951-0.13,1.154,0.792,1.668,3.313C353.245,155.895,353.619,159.645,354.486,159.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M356.102,149.928l3.102-1.666c-0.44-0.889-1.491-1.236-2.348-0.776 C356,147.946,355.662,149.039,356.102,149.928z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M345.011,169.555c0,0,4.601-0.927,6.209-1.782c1.076-0.572,1.962-1.564,2.223-2.2 c0,0-0.301,1.365-1.263,2.595c-1.177,1.503-7.169,2.611-7.169,2.611V169.555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M346.116,157.648c0,0.529,0.413,0.957,0.922,0.956c0.509-0.002,0.922-0.432,0.922-0.96 c0-0.529-0.413-0.957-0.922-0.955C346.529,156.689,346.116,157.12,346.116,157.648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M347.094,154.168l1.973,1.089c0.29-0.567,0.085-1.27-0.46-1.57 C348.063,153.386,347.385,153.602,347.094,154.168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M346.185,163.899l-2.104,0.79c0.208,0.603,0.849,0.916,1.43,0.697 C346.092,165.169,346.394,164.502,346.185,163.899z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M337.895,154.936l1.798-1.385c-0.366-0.515-1.066-0.622-1.563-0.24 C337.634,153.693,337.528,154.421,337.895,154.936z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M338.449,157.386c0,0.529,0.413,0.957,0.922,0.955c0.509-0.001,0.922-0.431,0.922-0.96 c0-0.529-0.413-0.957-0.922-0.955C338.862,156.427,338.449,156.857,338.449,157.386z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F28F8F"
    },
    points: "343.145,156.512 342.843,162.056 339.948,161.069  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#27DEBF"
    },
    points: "319.055,189.913 342.639,196.124 349.601,225.393 327.178,218.88  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M329.337,209.279c-0.219,0.598-1.509,2.257-4.255,2.127l-0.34-1.211L329.337,209.279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M334.607,210.195c0.104,0.78,1.708,2.225,4.419,3.128c3.085,1.028,7.818,0.484,7.818,0.484 l-0.424-1.456L334.607,210.195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.43,
      fill: "#455A64"
    },
    d: "M325.959,194.151c0,0-0.087-0.403-0.194-0.899c-0.107-0.497,1.276-0.518,3.092-0.048 l3.475,0.901c1.814,0.471,3.373,1.255,3.48,1.751l0.194,0.9L325.959,194.151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M324.324,190.758c-0.068-0.311,0.493-0.392,1.253-0.182l1.376,0.38c0,0-0.41-1.945,2.643-1.265 c3.054,0.68,3.722,2.889,3.722,2.889s0.657,0.187,1.469,0.417c0.812,0.23,1.547,0.668,1.643,0.977l0.174,0.56l-12.148-3.199 C324.454,191.335,324.393,191.068,324.324,190.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M325.998,191.729c1.113,0.269,1.575,0.416,1.742,1.182c0.19,0.875,0.267,1.517,0.267,1.517 l5.377,1.421c0,0-0.26-1.107-0.343-1.539c-0.083-0.432,0.101-0.691,0.956-0.465l0.072-0.343l-8.425-2.145L325.998,191.729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M325.813,194.235c0,0-0.087-0.402-0.194-0.899c-0.108-0.497,1.276-0.518,3.092-0.047l3.475,0.901 c1.814,0.471,3.373,1.255,3.48,1.752l0.194,0.899L325.813,194.235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M376.512,210.195l-7.926-6.126c0,0-16.595,3.125-18.471,3.273 c-1.877,0.148-3.344-1.703-4.059-3.545c-0.716-1.842-2.151-1.603-2.151-1.603s0.556,2.335,0.733,3.08 c0.177,0.746-4.145,1.348-6.639,0.503c-2.494-0.845-6.104,0.381-3.867,3.777c2.236,3.396,6.585,3.788,9.607,3.79 c0.835,0.001,2.318-0.063,3.777-0.252c0.977-0.127,1.949-0.226,2.933-0.295C356.633,212.356,373.701,211.078,376.512,210.195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M321.454,198.469c0,0,0.845,3.013,1.047,3.733c0.201,0.719,2.943,2.025,4.678,2.501 c1.733,0.476,3.629,1.041,2.809,3.464c-0.756,2.235-3.609,2.746-5.061,2.682c-1.452-0.063-3.44-1.451-4.224-3.689 c-0.999-2.854-0.461-5.903-0.857-7.57C319.447,197.924,320.586,197.475,321.454,198.469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M357.491,301.568v-0.845c-0.565,0.246-1.878,5.255-4.221,7.391 c-1.862,1.699-4.402,3.661-5.049,5.555c-0.672,1.97,3.538,3.058,5.278,2.749c2.021-0.358,5.525-1.781,6.405-3.102 c0.88-1.319,1.291-3.266,2.006-4.233c0.715-0.967,2.362-2.047,2.749-3.166c0.213-0.614-0.04-1.961-0.338-3.1 c-0.273-1.044-0.57-2.191-0.927-2.094c-0.001,0.128,0,0.644,0,0.644c-0.429,0.476-1.614,0.947-2.952,0.998 C359.58,302.398,357.484,302.228,357.491,301.568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M336.961,292.218c-0.307,0.011-0.557,0.443-1.232,1.176c-0.817,0.885-2.154,1.839-3.474,2.499 c-2.211,1.106-6.509,2.809-8.454,3.685c-1.216,0.547-1.158,2.015,0.098,2.851c1.256,0.835,4.289,1.438,7.931,0.623 c1.984-0.444,4.566-2.276,6.201-2.178c1.635,0.099,4.693,0.075,5.9-0.756c1.206-0.832,0.724-2.608,0.383-4.135 c-0.372-1.665-0.905-4.215-1.456-4.101l0.018,0.524c-0.71,1.074-4.323,1.514-5.883,0.722L336.961,292.218z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M81.305,288.629l3.693,5.132c0,0-1.711,1.003-5.364,1.142c-3.305,0.126-4.213-0.959-4.335-1.22 c-0.558-1.196,0.313-3.355,0.552-5.211L81.305,288.629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M75.299,283.473c0,0,0.56,4.661,0.603,5.662c0.043,1,4.549,1.321,5.403-0.506l0.14-5.699 L75.299,283.473z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M75.3,191.661c-3.084,4.799-6.016,9.026-6.641,14.419c-1.32,11.39,3.013,24.411,3.932,32.833 c0,0-2.91,3.783-2.907,8.229c0.002,3.48,5.615,36.331,5.615,36.331s4.083,1.244,6.146-0.543l3.858-60.433l-2.032-7.357 L75.3,191.661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M75.3,191.661c-3.084,4.799-6.016,9.026-6.641,14.419 c-1.32,11.39,3.013,24.411,3.932,32.833c0,0-2.91,3.783-2.907,8.229c0.002,3.48,5.615,36.331,5.615,36.331 s4.083,1.244,6.146-0.543l3.858-60.433l-2.032-7.357L75.3,191.661z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#27DEBF"
    },
    points: "103.766,169.147 124.076,178.898 111.891,206.306 92.955,195.384  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#27DEBF"
    },
    points: "121.692,179.4 111.167,202.757 96.59,194.362 104.858,171.365  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "104.858,171.365 121.692,179.4 110.329,203.014 94.413,193.923  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M108.515,174.751c0,0,0.178-0.376,0.397-0.841c0.219-0.464,1.612-0.267,3.11,0.441l2.868,1.355 c1.498,0.708,2.534,1.659,2.314,2.123l-0.397,0.841L108.515,174.751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M68.412,178.951c-1.486,4.221-4.412,10.92-3.468,12.265c0.944,1.345,6.577,1.063,9.72,0.944 c3.986-0.15,7.312-0.309,7.312-0.309l-0.666-6.986h-5.676l2.501-7.08L68.412,178.951z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M74.103,163.999c-2.07,3.404-6.252,15.401-6.252,15.401s1.485,1.922,4.407,2.652 c2.922,0.73,4.599,0.174,4.599,0.174l4.619-11.495L74.103,163.999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M74.103,163.999c-2.07,3.404-6.252,15.401-6.252,15.401s1.485,1.922,4.407,2.652 c2.922,0.73,4.599,0.174,4.599,0.174l4.619-11.495L74.103,163.999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M94.77,166.139c3.629,1.089,5.839,1.286,9.849,7.455c4.01,6.168,12.794,18.405,13.664,19.875 c1.21,2.045,1.731,4.48,0.687,6.359c-0.975,1.754-3.815,0.986-7.794-2.505c-3.848-3.376-11.473-12.926-11.473-12.926 S91.877,175.587,94.77,166.139z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFA8A7"
    },
    points: "91.871,158.136 90.885,166.814 82.333,167.8 83.567,156.289  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M73.56,145.47c0.706-8.011,5.048-11.31,8.407-12.102c6.775-1.597,12.816,0.862,15.554,5.608 c0.722,1.251,1.928,5.93-0.484,8.693C94.623,150.433,73.56,145.47,73.56,145.47"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M98.193,148.286c0,0,1.773,3.048,1.502,3.344c-0.272,0.296-1.525,0.556-1.525,0.556L98.193,148.286 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M92.793,138.641c1.832,1.084,4.991,3.074,5.431,10.078c0.45,7.189-0.926,9.403-1.954,10.284 c-0.693,0.593-4.233,0.395-5.97-0.256c-2.173-0.814-7.049-3.051-9.085-6.865c-2.395-4.487-2.608-10.297,0.574-12.387 C86.267,136.553,91.242,137.723,92.793,138.641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M93.334,138.971c0,0,1.27,6.608-0.938,10.611c0,0-1.008-2.608-3.234-2.004 c-2.242,0.608-2.209,3.552-0.565,5.15c1.646,1.598,3.369,0.92,3.369,0.92s-0.404,3.33-2.741,5.444c0,0-7.31,2.119-12.771-4.438 c-4.956-5.949-3.693-16.024,4.24-18.167C88.626,134.344,93.334,138.971,93.334,138.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M84.79,291.297c0,0,4.475-0.285,7.569-0.675c3.095-0.391,5.543,1.12,4.814,2.395 c-0.728,1.273-2.43,2.333-5.081,3.225c-2.272,0.765-4.995,1.32-7.367,2.03c-2.431,0.727-3.987,1.56-5.364,1.087 c-1.535-0.529-2.194-1.143-2.063-2.261c0.13-1.118,1.243-4.718,1.243-4.718L84.79,291.297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M79.843,286.341l-1.612,7.071c0,0-0.152,0.862,3.532,1.411c3.684,0.55,9.459-1.927,10.442-2.43 c0.983-0.504,1.101-1.505-2.517-1.305c-3.617,0.201-4.899,0.208-4.899,0.208l1.174-3.135L79.843,286.341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M85.303,222.497l-2.032-7.357c0,0-5.634-1.362-11.013-4.368c0,0,2.085,3.786,8.056,5.862 l3.11,9.458l0.268,21.644L85.303,222.497z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M75.3,191.661c-1.65,2.693-5.594,7.298-4.756,11.723c1.017,5.362,3.901,9.13,12.727,11.755 l8.277,29.975c0,0-4.311,4.033-5.628,7.87c-1.316,3.836-6.077,33.356-6.077,33.356s1.472,2.403,6.121,1.821 c0,0,16.21-37.024,17.355-39.408c1.145-2.384,1.887-4.166,1.372-8.049c-0.516-3.882-6.038-46.352-6.038-46.352L75.3,191.661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M75.3,191.661c-1.65,2.693-5.594,7.298-4.756,11.723 c1.017,5.362,3.901,9.13,12.727,11.755l8.277,29.975c0,0-4.311,4.033-5.628,7.87c-1.316,3.836-6.077,33.356-6.077,33.356 s1.472,2.403,6.121,1.821c0,0,16.21-37.024,17.355-39.408c1.145-2.384,1.887-4.166,1.372-8.049 c-0.516-3.882-6.038-46.352-6.038-46.352L75.3,191.661z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M73.795,164.621c0.646-1.704,2.688-3.121,4.521-2.622c5.771,1.571,14.747,3.637,16.452,4.14 l0.002-0.001c0,0-0.765,12.956,5.882,16.878c-0.313,2.476-1.999,11.337-1.999,11.337s-7.99,3.872-14.568,1.964 c-6.579-1.908-8.785-4.657-8.785-4.657l3.291-5.364c-0.706-1.743-3.419-7.66-5.175-13.161 C72.585,170.537,73.15,166.325,73.795,164.621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M73.795,164.621c0.646-1.704,2.688-3.121,4.521-2.622c5.771,1.571,14.747,3.637,16.452,4.14 l0.002-0.001c0,0-0.765,12.956,5.882,16.878c-0.313,2.476-1.999,11.337-1.999,11.337s-7.99,3.872-14.568,1.964 c-6.579-1.908-8.785-4.657-8.785-4.657l3.291-5.364c-0.706-1.743-3.419-7.66-5.175-13.161 C72.585,170.537,73.15,166.325,73.795,164.621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "#27DEBF"
    },
    d: "M77.693,184.189c0.084,0.193,6.622,3.697,8.564,4.233 c-3.063-0.152-5.607-0.872-7.666-2.125L77.693,184.189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M79.393,135.148c0,0-2.748-4.671-9.449-3.462c-6.701,1.209-9.433,8.333-9.332,12.843 c0.102,4.509,1.609,7.658-2.434,12.992c-3.312,4.369-2.143,10.838,2.873,13.633c5.393,3.006,6.701-2.227,5.449-6.684 c-1.436-5.113,3.913-5.997,5.337-9.873c1.424-3.875-1.378-12.017,0.421-14.759c1.958-2.984,4.699-2.578,6.019-1.563 L79.393,135.148z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M94.77,166.139c0,0,3.236,0.677,5.247,1.661c2.207,1.081,10.783,14.554,10.783,14.554 s-0.614,5.065-7.631,7.079l-4.222-5.244C98.947,184.189,92.905,175.078,94.77,166.139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M94.77,166.139c0,0,3.236,0.677,5.247,1.661c2.207,1.081,10.783,14.554,10.783,14.554 s-0.614,5.065-7.631,7.079l-4.222-5.244C98.947,184.189,92.905,175.078,94.77,166.139z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M100.22,185.769c0,0-2.871-3.159-4.093-7.341c0,0-0.013,5.817,3.833,8.832L100.22,185.769z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M100.22,185.769c0,0-2.871-3.159-4.093-7.341c0,0-0.013,5.817,3.833,8.832L100.22,185.769z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M109.245,171.134c0.136-0.29,0.748-0.276,1.367,0.032l1.121,0.558c0,0,0.87-1.816,3.463-0.726 c2.594,1.09,1.807,3.185,1.807,3.185s0.532,0.271,1.189,0.606c0.656,0.334,1.101,0.843,0.994,1.137l-0.195,0.531l-9.992-4.798 C108.999,171.659,109.109,171.424,109.245,171.134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M110.272,172.271c0.933,0.416,1.296,0.622,0.959,1.337c-0.386,0.818-0.731,1.408-0.731,1.408 l4.421,2.122c0,0,0.469-1.038,0.67-1.44c0.201-0.402,0.554-0.607,1.258-0.27l0.297-0.297l-6.981-3.251L110.272,172.271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M108.441,174.5c0,0,0.178-0.376,0.397-0.841c0.22-0.464,1.612-0.267,3.11,0.441l2.868,1.356 c1.498,0.708,2.534,1.658,2.315,2.122l-0.397,0.841L108.441,174.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummyAm);
export default __webpack_public_path__ + "static/media/dummy-am.d07131c94d8f7e109ac5b7645460ea26.svg";
export { ForwardRef as ReactComponent };